import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';
import { IEBreakPoints } from 'theme/@types';
import fontsConfig from 'theme/fonts';

interface IMuiSelect {
  defaultProps?: ComponentsProps['MuiSelect'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiSelect'];
  variants?: ComponentsVariants<Theme>['MuiSelect'];
}

const MuiSelectConfig: IMuiSelect = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 48,
      textTransform: 'none',

      '&.MuiInputBase-root ': {
        outline: 'none',

        svg: {
          position: 'absolute',
          width: 15,
          right: 20,
          top: '50%',
          transform: 'translateY(-50%)',
        },

        '&:hover, &:focus-visible': {
          outline: 'none',
        },

        '.MuiInputBase-input': {
          paddingLeft: 20,
          paddingTop: 10,
          paddingBottom: 10,
          fontSize: fontsConfig.sizes.defaultS,
        },

        '.MuiOutlinedInput-notchedOutline': {
          outline: 'none',
          borderColor: theme.palette.sixth.light,
        },
      },

      '&:hover': {
        outline: 'none',
        boxShadow: 'none',
      },
      [theme.breakpoints.up(IEBreakPoints.LAPTOP)]: {
        '&.MuiInputBase-root ': {
          '.MuiInputBase-input': {
            paddingTop: 13.5,
            paddingBottom: 13.5,
            fontSize: fontsConfig.sizes.default,
          },
        },
      },

      // [`@media (min-width:${breakPoints.laptop}px)`]: {
      //   '&.MuiInputBase-root ': {
      //     '.MuiInputBase-input': {
      //       paddingTop: 13.5,
      //       paddingBottom: 13.5,
      //       fontSize: fontsConfig.sizes.default,
      //     },
      //   },
      // },
    }),
  },
};

export default MuiSelectConfig;
